/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {getPagesFromContext, markBlockAsDeprecated} from "../../helpers";

function defineBlock(formPages) {

    let forms = [];
    let formsIdList = [];
    formPages.forEach((element) => {

        let formFields = element[1].split("<<<>>>");
        let formId = formFields[0];
        if (!formsIdList.includes(formId)) {
            let formName = element[0].split(" > ");
            formName = formName[0];
            forms.push([formName,element[1]]);
            formsIdList.push(formId);
        }
    });

    return {
        init: function () {
            markBlockAsDeprecated(this);
            this.appendDummyInput()
                .appendField("reset form ")
                .appendField(new Blockly.FieldDropdown(forms), "FORMSLUG");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Reset a form or a screen in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let formSlug = block.getFieldValue('FORMSLUG');
            let formFields = formSlug.split("<<<>>>");
            let formDataGenyId = formFields[0];
            let pageId = formFields[1];

            let code = `
                BlocklyPromises.push(actionsModule.getExecuteActionPromise({
                    action: {
                        actionType: "resetForm"
                    },
                    formDataGenyId: "${formDataGenyId || pageId}",
                }))
            `;

            return code;
        }
    }
}

const ResetPage = function (props) {
    let name = "snap_action_reset_page";
    ResetPage.blockName = name;

    const formPages = getPagesFromContext(props.context);
    if (!formPages.length) {
        return null;
    }

    Blockly.Blocks[name] = defineBlock(formPages);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return (
        <block type={name}></block>
    );
};

ResetPage.propTypes = {
    context: PropTypes.object.isRequired,
};

export default ResetPage;
